import * as Yup from 'yup';
import moment from 'moment';
import {
  TYPE_MAPPINGS, TASK_TYPES, WEEK_DAYS_MAPPINGS, WEEK_DAYS_REVERSE_MAPPINGS, ROLES,
} from './constants';

export const taskValidationSchema = Yup.object().shape({
  day: Yup.number('Day should be a valid number').required('required'),
  task: Yup.number('Task should be a valid number').required('required'),
  time: Yup.number('Time should be a valid number').required('required'),
  name: Yup.string().required('Name is required!'),
  title: Yup.string().required('Title is required!'),
  type: Yup.string().oneOf(Object.keys(TYPE_MAPPINGS), 'Task type is not valid'),
  taskType: Yup.string().oneOf(Object.keys(TASK_TYPES), 'Type is not valid'),
});

export const templateValidationSchema = Yup.object().shape({
  type: Yup.string().oneOf(Object.keys(TYPE_MAPPINGS), 'Task type is not valid'),
  name: Yup.string().required('Name is required!'),
  title: Yup.string().required('Title is required!'),
  time: Yup.number('Time should be a valid number').required('required'),
  taskType: Yup.string().oneOf(Object.keys(TASK_TYPES), 'Type is not valid'),
});

export const multiTemplateValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  days: Yup.array().required('Week Days are required'),
});

export const callTypeValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required!'),
  title: Yup.string().required('Title is required!'),
  platform: Yup.string().oneOf(['mobile', 'web'], 'Invalid Platform!'),
  description: Yup.string().required('Description is required'),
  maxParticipants: Yup.number().min(1, 'Atleast one participant must paricipate').required('Paricipants should be a number'),
});

export const callTypeEditValidationSchema = Yup.object().shape({
  name: Yup.string('Name must be String'),
  title: Yup.string('Title must be String'),
  description: Yup.string('Description must be String'),
  maxParticipants: Yup.number().min(1, 'Atleast one participant must paricipate'),
});

export const DashboardUserValidationSchema = Yup.object().shape({
  name: Yup.string('Name must be String').required('name is required'),
  email: Yup.string('email must be String').required('email is required'),
  password: Yup.string('password must be String').required('password is required'),
  role: Yup.string().oneOf(Object.values(ROLES)).required('role is required'),
});

export const TherapistValidationSchema = Yup.object().shape({
  name: Yup.string('Name must be String').required('name is required'),
  email: Yup.string('email must be String').required('email is required'),
  password: Yup.string('password must be String').required('password is required'),
  conPassword: Yup
    .string('password must be String')
    .required('All fields are required')
    .oneOf([Yup.ref('password'), null], 'Password Does not match'),
});

export const callSlotValidationSchema = Yup.object().shape({
  callType: Yup.string().required('Call Type is required'),
  url: Yup.string().required('URL is required'),
  isActive: Yup.boolean().required('Active Status is required'),
  duration: Yup.number('Duration in minutes'),
  dateTime: Yup.string().required('Date And time is required'),
  // moderator: Yup.string().required('Moderator is required'),
  weekDays: Yup.array().required('Week Days are required'),
});

export const callSlotEditValidationSchema = Yup.object().shape({
  callType: Yup.string('Call must be String'),
  url: Yup.string('URL must be String'),
  isActive: Yup.boolean('Active Status must be boolean'),
  duration: Yup.number('Duration in minutes'),
  dateTime: Yup.string('Date And time must be valid string'),
  // moderator: Yup.string('Moderator must be a string'),
  weekDays: Yup.array().required('Week Days are required'),
});

export const planValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required!'),
  desc: Yup.string().required('Description is required!'),
  days: Yup.number('Free Trial should be valid number of days').required('required'),
  version: Yup.number('Version should be a valid number').required('required'),
});

export const videoExerciseValidationSchema = Yup.object().shape({
  type: Yup.string().required('Video type is required!'),
  name: Yup.string().required('Name is required!'),
  url: Yup.string().required('URL is required!'),
  quizes: Yup.array().min(0),
});

export const quizValidationSchema = Yup.object().shape({
  question: Yup.string().required('Question is required!'),
  options: Yup.array().min(2).required(),
  answerIndexes: Yup.array().min(1).required(),
});

export function getISTOfUTC(UTCDateString) {
  if (!UTCDateString) return undefined;
  const dateUTC = new Date(UTCDateString);
  const dateTime = new Date(dateUTC.getTime());
  dateTime.setHours(dateTime.getHours() + 5);
  dateTime.setMinutes(dateTime.getMinutes() + 30);
  return dateTime;
}

export function getUTCOfIST(ISTDateString) {
  if (!ISTDateString) return undefined;
  const dateIST = new Date(ISTDateString);
  const dateTime = new Date(dateIST.getTime());
  dateTime.setHours(dateTime.getHours() - 5);
  dateTime.setMinutes(dateTime.getMinutes() - 30);
  return dateTime;
}

export const getWeekDayDate = (dayNumber, date) => {
  const newDate = new Date(date);
  const returndate = newDate.setDate(newDate.getDate() + dayNumber - moment.utc(newDate).weekday());
  if (returndate < newDate) return newDate.setDate(newDate.getDate() + dayNumber - moment.utc(newDate).weekday() + 7);
  return newDate.setDate(newDate.getDate() + dayNumber - moment.utc(newDate).weekday());
};

export function getWeekDaysDates(weekDays, date) {
  const weekDaysDates = weekDays.map((weekDay) => { return getWeekDayDate(WEEK_DAYS_MAPPINGS[weekDay], date); });
  return weekDaysDates;
}

export function getWeekDays(weekDaysDates) {
  const weekDays = weekDaysDates.map((weekDayDate) => {
    return WEEK_DAYS_REVERSE_MAPPINGS[moment.utc(weekDayDate).weekday()];
  });
  return weekDays;
}
